class MFRAfterBae {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      inner: ".after-bae__inner",
      ingredient: ".after-bae__ingredient",
    };

    this.minimumDropped = this.$element.data( "animate-after" );

    this.animationDuration =
      this.$element.css("--after-bae-transition-duration").replace("s", "") *
      1000;
    this.explosionGIFUrl = this.$element.data( "explosion" );
    this.init();
  }

  init() {
    this.$ingredient = this.$element.find(this.selectors.ingredient);
    this.$inner = this.$element.find(this.selectors.inner);
    this.$wrapper = this.$element;
    window.afterBaeAnimate = this.animateAfterBae.bind(this);
    window.initIngredientsPosition = this.initIngredientsPosition.bind(this);

    // const windowWidth = $( window ).width();
    // $( window ).on( "resize", () => {
    //   if( $( window ).width() != windowWidth ) {
    //     this.initIngredientsPosition;
    //   }
    // } );
    // this.initIngredientsPosition();
    this.initDrag();
  }

  animateAfterBae() {
    this.$element.removeClass("mixed");
    this.$element.addClass("mixing");
    setTimeout(() => {
      this.$element.addClass("mixed").removeClass("mixing");
    }, this.animationDuration - 100);
  }

  initIngredientsPosition() {
    const wrapper = this.$wrapper;
    const elements = this.$ingredient;
    const specificElements = this.$inner;
    const wrapperWidth = wrapper.width();
    const wrapperHeight = wrapper.height();
    const scales = [0.5, 0.75, 1];
    const scale = scales[Math.floor(Math.random() * (2 - 0 + 1) + 0)];

    const positions = [];

    elements.each(function () {
      const element = $(this);
      const elementWidth = element.width();
      const elementHeight = element.height();
      let randomLeft, randomTop;
      let overlapsSpecificElement, overlapsOtherElement;
      const scale = scales[Math.floor(Math.random() * (2 - 0 + 1) + 0)];

      do {
        randomLeft = Math.random() * (wrapperWidth - elementWidth);
        randomTop = Math.random() * (wrapperHeight - elementHeight);

        const rect1 = {
          left: randomLeft,
          top: randomTop,
          right: randomLeft + elementWidth,
          bottom: randomTop + elementHeight,
        };

        overlapsSpecificElement = specificElements
          .toArray()
          .some(function (specificElement) {
            var rect2 = specificElement.getBoundingClientRect();
            return !(
              rect1.right < rect2.left ||
              rect1.left > rect2.right ||
              rect1.bottom < rect2.top ||
              rect1.top > rect2.bottom
            );
          });

        overlapsOtherElement = positions.some(function (position) {
          return !(
            rect1.right < position.left ||
            rect1.left > position.right ||
            rect1.bottom < position.top ||
            rect1.top > position.bottom
          );
        });
      } while (overlapsSpecificElement || overlapsOtherElement);

      positions.push({
        left: randomLeft,
        top: randomTop,
        right: randomLeft + elementWidth,
        bottom: randomTop + elementHeight,
      });

      gsap.to(element, {
        left: randomLeft,
        top: randomTop,
        transform: "unset",
        scrollTrigger: {
          trigger: this.$element,
          start: "top 25%",
        },
      });

      gsap.to(element.find( "img" ), {
        scale: scale
      } );
    });

    this.initDrag();
  }

  initDrag() {
    this.initGrabCursor();
    this.initDropZone();

    interact(
      `#${this.$element.attr("id")} ${this.selectors.ingredient}`
    ).draggable({
      // enable inertial throwing
      inertia: true,
      // keep the element within the area of it's parent
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: "parent",
          endOnly: true,
        }),
      ],
      // enable autoScroll
      autoScroll: false,

      listeners: {
        // call this function on every dragmove event
        move: this.dragMoveListener,

        // call this function on every dragend event
        end(event) {},
      },
    });

    // this function is used later in the resizing and gesture demos
    window.dragMoveListener = this.dragMoveListener;
  }

  dragMoveListener(event) {
    var target = event.target;
    // keep the dragged position in the data-x/data-y attributes
    var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
    var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

    // translate the element
    gsap.set($(target), {
      x: x,
      y: y,
    });

    // update the posiion attributes
    target.setAttribute("data-x", x);
    target.setAttribute("data-y", y);
  }

  initDropZone() {
    interact(`#${this.$element.attr("id")} ${this.selectors.inner}`).dropzone({
      // only accept elements matching this CSS selector
      accept: `#${this.$element.attr("id")} ${this.selectors.ingredient}`,
      // Require a 75% element overlap for a drop to be possible
      overlap: 0.75,

      // listen for drop related events:

      ondropactivate: function (event) {
      },
      ondragenter: function (event) {
      },
      ondragleave: function (event) {
      },
      ondrop: (event) => {
        const ingredient = $(event.relatedTarget);
        ingredient.addClass( "dropped" );
        ingredient.find( ".explosion" ).addClass( "play" );

        setTimeout( () => {
          ingredient.find(".explosion").addClass("played");
          if (
            $(`#${this.$element.attr("id")} ${this.selectors.ingredient}.dropped`)
              .length >= this.minimumDropped
          ) {
            this.$ingredient
              .addClass( "not-draggable" )
              .css("pointer-events", "none");
            this.animateAfterBae();
          }
        }, 1000 );
      },
      ondropdeactivate: function (event) {
      },
    });
  }

  disableAllIngredient() {
    $(`#${this.$element.attr("id")} ${this.selectors.ingredient}.dropped`);
  }

  initGrabCursor() {
    this.$ingredient.on("mousedown", (e) =>
      $(e.currentTarget).addClass("grabbing")
      
    );
    this.$ingredient.on("mouseup", (e) =>
      $(e.currentTarget).removeClass("grabbing")
    );
  }
}